<template>
  <div>
    <div class="row">
      <div class="col">
        <div
          :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} shadow-table border-radius-20 p-3 position-relative`"
        >
          <Loading v-if="loading" />
          <h3 class="my-3">
            {{ dataId ? `Editar ${currentName ? currentName : "-"}` : "" }}
          </h3>
          <div class="form-floating text-dark my-3">
            <input
              v-model="form.name"
              type="text"
              class="form-control border-secondary"
              id="formName"
              maxlength="55"
            /><span class="character-counter" v-if="form.name"
              >{{ form.name.length }} / 55</span
            >
            <label for="formName">Nombre</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("name") }}
            </p>
          </div>
          <div class="form-floating text-dark my-3">
            <textarea
              v-model="form.description"
              class="form-control border-secondary text-area-padding"
              placeholder="Leave a comment here"
              id="formDescription"
              style="height: 100px"
              maxlength="255"
            ></textarea
            ><span class="character-counter" v-if="form.description"
              >{{ form.description.length }} / 255</span
            >
            <label class="label-form-description" for="formDescription"
              >Descripción</label
            >
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("description") }}
            </p>
          </div>
          <div class="d-flex justify-content-end">
            <button
              type="button"
              @click="saveData()"
              class="btn btn-primary"
              :disabled="validateData()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
      <div class="col" v-if="dataId">
        <div
          :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} shadow-table border-radius-20 p-3`"
        >
          <h3 class="my-3">Estructura de Carpetas</h3>
          <Tree
            v-if="folders"
            :items="getFolders"
            :folder-structure-name="currentName"
            :folder-list="getFolderList"
            @set-data="setData"
            :key="componentKey"
            @show-modal="showConfirmationModal"
          />
          <ModalGlobal v-if="showModal" @close-modal="showModal = false" @duplicate-folder="duplicateFolder" modalType="duplicateData" modalTitle="¿Estás seguro de que quieres duplicar la carpeta?" :modalText="'Al duplicar la carpeta: \/' + selectedFolder.name + '\/ se creará una copia de la misma con todas sus subcarpetas '"></ModalGlobal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import Loading from "@/components/Loading.vue";
import Tree from "@/components/Tree.vue";
import ModalGlobal from '@/components/ModalGlobal.vue'
export default {
  name: "template-index",
  components: { Tree, Loading, ModalGlobal },
  emits: ["setData", "setBreadcrumb"],
  props: {
    dataId: { default: null },
  },
  data() {
    return {
      breadcrumb: [{ text: "Plantillas", link: { name: "templates" } }],
      form: { name: null, description: null },
      currentName: "",
      folders: [],
      folderList: [],
      selectedItems: [],
      componentKey: 0,
      loading: false,
      showModal: false,
      selectedFolder: null,
    };
  },
  created() {
    if (this.dataId) {
      this.setData();
      this.breadcrumb.push({ text: "Editar", link: { name: "templates" } });
    } else {
      this.breadcrumb.push({ text: "Crear", link: { name: "templates" } });
    }
    this.$emit("setBreadcrumb", this.breadcrumb);
    this.setOpenedFolders([]);
  },
  methods: {
    ...mapMutations("general", ["setOpenedFolders"]),
    showConfirmationModal(item){
        this.showModal = true
        this.selectedFolder = item
      },
      duplicateFolder(){
        let app = this;
        let item = app.selectedFolder
        this.axios.post(`/folders/${item.id}/duplicate_folder`).then(() => {
          this.setData()
        }).catch(error => {
          console.log(error)
        });
      },
    setData(dataId) {
      let app = this;
      this.axios
        .get(`folder_structures/${dataId ? dataId : this.dataId}/folders`)
        .then((result) => {
          app.form = result.data.body;
          app.folders = [{ ...app.form }];
          app.currentName = app.form.name;
          app.componentKey += 1;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .get(`folder_structures/${dataId ? dataId : this.dataId}/list_folders`)
        .then((result) => {
          app.folderList = [{ id: null, complete_name: "" }];
          app.folderList = app.folderList.concat(result.data.body);
          app.componentKey += 1;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveData() {
      let app = this;
      this.loading = true;
      if (this.dataId) {
        this.axios
          .put(`folder_structures/${this.dataId}`, {
            folder_structure: this.form,
          })
          .then(() => {
            app.loading = false;
            app.$router
              .push({
                name: "templates",
                params: { alertMsg: "Guardado correcto!" },
              })
              .catch();
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      } else {
        this.axios
          .post("folder_structures", { folder_structure: this.form })
          .then((result) => {
            app.loading = false;
            app.$router
              .push({
                name: "edit-template-form",
                params: {
                  dataId: result.data.body.id,
                  alertMsg: "Guardado correcto!",
                },
              })
              .catch();
            app.setData(result.data.body.id);
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      }
    },
    validateData() {
      if (this.form.name && this.form.description) return false;
      return true;
    },
    validateDataMessage(field) {
      switch (field) {
        case "name":
          if (!this.form.name) return "Debe ingresar un nombre";
          break;
        case "description":
          if (!this.form.description) return "Debe ingresar una descripción";
          break;
      }
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    getFolderList() {
      return this.folderList;
    },
    getFolders() {
      return this.folders;
    },
  },
};
</script>
